import React from "react";
import { connect } from "react-redux";

import { AudioLevelIndicator, MEDIA_TYPE, VideoTrack } from "../../media";
import { getTracksByParticipantId, isParticipantMediaMuted } from "../../tracks";
import { getParticipantById, getParticipantDisplayName } from "../function";
import { BsFillMicFill, BsFillMicMuteFill, BsCameraVideoOff } from "react-icons/bs";
import PinnedParticipant from "./PinnedParticipant";

function ParticipantView({ 
    videoTrack, audioTrack, 
    isAudioMuted, participantName, participantId, pinned  
}) {  
    if (!participantId) return null;
    return (
        <>
            <div className="videoWrap" >
                { videoTrack && !videoTrack.muted
                    ? <VideoTrack videoTrack = { videoTrack } /> 
                    :
                    <div className="default" style={{minHeight: "98px"}}> 
                        <dl className="center">
                            <BsCameraVideoOff color={"#fff"} />
                        </dl>
                    </div>
                }
                <div className="namePlate">
                    <span className="overText"> {participantName} </span>
                    
                    <span className={"mike"}>
                        {!isAudioMuted && <BsFillMicFill size={12} color={"#128ed7"} stroke={"#fff"}/>}
                        {isAudioMuted && <BsFillMicMuteFill size={12} color={"red"} />}
                    </span>  
                </div>

                <PinnedParticipant 
                    pinLayoutMode={true} pinned={pinned} participantId={participantId} 
                    hidePinLayout={APP.layout.container.pin} /> 
                <AudioLevelIndicator audioTrack={audioTrack} />
            </div>
        </>
    )
}

function _mapStateToProps(state, ownProps) {
    const { participantId } = ownProps;
    const { bridgeParticipant } = state['features/base/participants'];
    
    const participant = getParticipantById(state, participantId);

    if (participant) {
        const participantName = getParticipantDisplayName(state, participantId);
        const isAudioMuted = isParticipantMediaMuted(participant, MEDIA_TYPE.AUDIO, state);

        let videoTrack, audioTrack = null;    
        const bridge_session_id = participant.local ? "local" : bridgeParticipant.get(participant.user_uuid);
        if (bridge_session_id) {
            videoTrack = getTracksByParticipantId(state, bridge_session_id, MEDIA_TYPE.VIDEO);
            audioTrack = getTracksByParticipantId(state, bridge_session_id, MEDIA_TYPE.AUDIO);
        }        
        return {    
            participantId,
            participantName,
            isAudioMuted,
            videoTrack,
            pinned: participant.pinned,
            audioTrack
        }
    } else {
        return {
            participantId: null
        }
    }
    
    
}

export default connect(_mapStateToProps)(ParticipantView);